import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, TouchableOpacity, ScrollView, Platform, Linking, Image } from 'react-native';
import { Colors, Button, Input, Text, Checkbox } from '../components';
import AuthController from '../controllers/authController';
import UserController from '../controllers/userController'
import AsyncStorage from '@react-native-async-storage/async-storage';
import { config } from '../../config';
import AnimatedCodeInput from "@brainsbeards/react-native-animated-code-input";

class SignUpPriceSelection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display_section: 'phone_number_input',  // 'phone_number_input' 'validation_input' 'user_info_input'
      user_email: '',
      user_confirm_email: '',
      user_first_name: '',
      user_last_name: '',
      user_phone_number: '',
      phone_validation_code: '',
      email_verified: true,
      phone_verified: true,
      phone_number_valid: false,
      register_form_valid: false,
      tos_accepted: false
    }

    this.update_field = this.update_field.bind(this);

    this.update_phone_number = this.update_phone_number.bind(this);
    this.send_phone_code = this.send_phone_code.bind(this);
    this.validate_phone_code = this.validate_phone_code.bind(this);
    this.validateRegisterForm = this.validateRegisterForm.bind(this);
    this.backToPhone = this.backToPhone.bind(this);
    this.completeSignup = this.completeSignup.bind(this);
  } //aleksczajka@gmail.com

  async componentDidMount() {

  }

  update_phone_number(phone_number, phone_number_valid) {
    this.setState({
      phone_number,
      phone_number_valid
    })
  }

  async send_phone_code() {
    this.setState({loading: true}, async () => {
      let response = await AuthController.sendRegisterPhoneCode({phone: this.state.phone_number});
      console.log('responssdfe', response)
      if(response.success) {
        await AsyncStorage.setItem('sign_up_step', 'validation_input');
        await AsyncStorage.setItem('phone_number', this.state.phone_number);
        this.setState({ loading: false, display_section: 'validation_input' })
      } else {
        this.setState({ phone_send_error: response.error, loading: false })
      }
    });

    await AuthController.updateCareSignUpSession({ phone_number: this.state.phone_number, has_submitted_phone_number: true });
  }

  async backToPhone() {
    await AsyncStorage.setItem('sign_up_step', 'phone_number_input');
    this.setState({ display_section: 'phone_number_input', phone_number_valid: false});
  }

  async validate_phone_code() {
    this.setState({loading: true}, async () => {
      let partner_id = await AsyncStorage.getItem('partner_id');
      let phone      = this.state.phone_number;
      let code       = this.state.phone_validation_code;
      let response   = await AuthController.validateRegisterPhoneCode({phone, code, partner_id});

      if(response.success) {
        await AsyncStorage.setItem('sign_up_step', 'user_info_input');

        console.log('user response.data', response.data)

        if(response.data) {
          // If subscription exists, log the user in
          if(response.data.subscription_exists) {
            this.props.on_subscription_exists();
          } else {
            let existing_user, register_form_valid = this.state.register_form_valid, user_email, user_first_name, user_last_name;

            if(response.data.user_id) {
              let user = response.data;
              existing_user = true;

              user_email = user.email;
              user_first_name = user.first_name;
              user_last_name = user.last_name;
              register_form_valid = user.email && user.first_name && user.last_name;
            }
            this.setState({ loading: false, display_section: 'user_info_input', existing_user, user_email, user_first_name, user_last_name, register_form_valid })
          }
        } else {
          this.setState({ loading: false, display_section: 'user_info_input' })
        }
      } else {
        this.setState({ phone_verify_error: response.error, loading: false })
      }
    });

    await AuthController.updateCareSignUpSession({ has_submitted_phone_code: true });
  }

  completeSignup = async () => {
    if (this.state.loading) {
      return;
    }

    this.setState({loading: true}, async () => {
      let user_info = {
        email: this.state.user_email,
        phone_number: this.state.phone_number,
        first_name: this.state.user_first_name,
        last_name: this.state.user_last_name,
        skip_email: true
      }

      if(this.props.continue_btn_action && this.validateRegisterForm()) {

        let existing_user = this.state.existing_user;

        if(existing_user) {
          let profile_save_return = await UserController.updateProfileWithEmail(user_info);

          if(profile_save_return.success) {
            this.props.continue_btn_action(user_info);
            this.setState({ complete_signup_error: null, loading: false })
          } else {
            this.setState({ complete_signup_error: profile_save_return.error, loading: false })
          }
        } else {
          console.log('CREATING NEW USER');
          let response = await AuthController.completeRegistration(user_info);
          console.log('response', response);
          if(response.success) {
            let user_data = {
              email: user_info.email,
              first_name: user_info.first_name,
              last_name: user_info.last_name,
              phone_number: user_info.phone_number,
              has_subscribed: 'false'
            }

            console.log('user_data', user_data);

            let registration_data = {
              partner_code: config.SELECTED_PARTNER_CODE,
              status: 'REGISTERED'
            }

            console.log('registration_data', registration_data);

            let air_table_response  = await UserController.sendDataToAirTable(user_data);

            console.log('air_table_response', air_table_response);
            let update_registration = await UserController.updateUserPartnerRegistration(registration_data);
            console.log('update_registration', update_registration);

            this.props.continue_btn_action(user_info);
            this.setState({ complete_signup_error: null, loading: false, existing_user: true })
          } else {
            this.setState({ complete_signup_error: response.error, loading: false })
          }
        }

      } else {
        this.setState({
          loading: false
        })
      }
    })

    await AuthController.updateCareSignUpSession({ has_submitted_profile: true, email: this.state.user_email, first_name: this.state.user_first_name, last_name: this.state.user_last_name });
  }

  validateRegisterForm() {
    let user_info = {
      email: this.state.user_email,
      phone_number: this.state.user_phone_number,
      first_name: this.state.user_first_name,
      last_name: this.state.user_last_name
    }

    let all_values = !!user_info.email && !!user_info.first_name && !!user_info.last_name;
    let emails_match = true; // this.state.user_confirm_email === user_info.email;

    let valid = all_values && emails_match;

    return valid;
  }

  update_field(name, value) {
    this.setState({
      [name]: value
    }, () => {
      this.setState({
        register_form_valid: this.validateRegisterForm()
      })
    });
  }

  render_user_inputs_section = () => {

    if (this.state.display_section !== 'user_info_input') {
      return null;
    }

    let complete_signup_error = this.state.complete_signup_error;
    let { user_email, user_first_name, user_last_name } = this.state;

    return <View style={{ alignItems: 'center' }}>
      <View>
        <View style={{ height: 90, width: 330, paddingLeft: 10 }}>
          <Text style={{ fontSize: 32, fontWeight: '500' }}>Account Details</Text>
          <Text style={{ fontSize: 16, color: '#575762' }}>Let's sort out some account information.</Text>
        </View>

        <Input placeholder={ 'Enter Email Address' }
               label={ 'Email Address' }
               style={{ marginBottom: 10 }}
               autoCorrect={false}
               value={user_email}
               onChangeText={(input_text)=>{this.update_field('user_email', input_text)}}/>

        { /*
        <Input placeholder={ 'Confirm Email Address' }
               label={ 'Confirm Email Address' }
               style={{ marginBottom: 10 }}
               onChangeText={(input_text)=>{this.update_field('user_confirm_email', input_text)}}/>
        */ }

         <Input placeholder={ 'Enter First Name' }
                label={ 'First Name' }
                style={{ marginBottom: 10 }}
                value={user_first_name}
                onChangeText={(input_text)=>{this.update_field('user_first_name', input_text)}}/>

          <Input placeholder={ 'Enter Last Name' }
                 label={ 'Last Name' }
                 style={{ marginBottom: 10 }}
                 value={user_last_name}
                 onChangeText={(input_text)=>{this.update_field('user_last_name', input_text)}}/>
      </View>
      {complete_signup_error ? <Text style={styles.error_message}>{complete_signup_error}</Text> : null}
      <Button title='Continue'
              inactive={!this.state.register_form_valid}
              style={{ width: 335, marginBottom: 10, marginTop: 15 }}
              loading={this.state.loading}
              onPress={this.completeSignup}/>
    </View>
  }

  render_phone_number_input_section = () => {
    if (this.state.display_section !== 'phone_number_input') {
      return null;
    }

    let valid = this.state.phone_number_valid && this.state.tos_accepted;
    let phone_send_error = this.state.phone_send_error;
    let loading = this.state.loading;
    let is_web  = Platform.OS === 'web';

    return <View style={{ alignItems: 'center' }}>
      { is_web ? <View>
                    <Image resizeMode='contain' style={{ width: 300, height: 80 }} source={{ uri: 'https://teletailstest.s3.amazonaws.com/profile/1660997578916.png' }} />
                  </View>
               : null }
      <View style={{ height: 110, width: 330, marginTop: 15 }}>
        <Text style={{ fontSize: 32, fontWeight: '500', textAlign: 'center' }}>Let's Get Started!</Text>
        <Text style={{ fontSize: 16, color: '#575762', textAlign: 'center' }}>Let's begin with some details to set up your account.</Text>
      </View>

      <Input value={this.state.user_phone_number}
             type={'phone'}
             placeholder={ 'Moible Phone Number' }
             style={{ marginBottom: 10 }}
             onChangeText={this.update_phone_number} />

      { this.render_tos_pp() }

      {phone_send_error ? <Text style={styles.error_message}>{phone_send_error}</Text> : null}
       <Button title='Send Verification Code'
               inactive={!valid}
               loading={loading}
               style={{ width: 300, marginBottom: 10, marginTop: 15 }}
               onPress={this.send_phone_code}/>
    </View>
  }

  render_tos_pp = () => {

    return <View style={{ flexDirection: 'row', width: 300, marginTop: 30, paddingRight: 10, marginBottom: 10 }}>
      <View style={{ paddingTop: 5 }}>
        <Checkbox checked={this.state.tos_accepted} label_color={ Colors.PRIMARY } style={{ marginRight: 10, borderColor: Colors.PRIMARY }} onPress={ () => { this.setState({ tos_accepted: !this.state.tos_accepted }) }} />
      </View>
      <View style={{ flex: 1 }}>
        <Text style={{ fontSize: 16, color: '#575762', letterSpacing: 0.2 }}>By checking this box, you are agreeing to our <Text onPress={ () => { Linking.openURL('https://www.teletails.com/tospet') }} style={{ fontWeight: 'bold', color: Colors.PRIMARY }}>Terms & Conditions</Text> and <Text onPress={ () => { Linking.openURL('https://www.teletails.com/privacypolicy') }} style={{ fontWeight: 'bold', color: Colors.PRIMARY }}>Privacy Policy.</Text></Text>
      </View>
    </View>
  }

  render_validation_code_section = () => {
    if (this.state.display_section !== 'validation_input') {
      return null;
    }

    let phone_verify_error = this.state.phone_verify_error;
    let loading            = this.state.loading;

    return <View style={{ alignItems: 'center' }}>

        <View style={{ height: 110, width: 330, marginTop: 80 }}>
          <Text style={{ fontSize: 32, fontWeight: '500', textAlign: 'center' }}>Phone Validation</Text>
          <Text style={{ fontSize: 16, color: '#575762', textAlign: 'center' }}>Enter the validation code that you have received to continue.</Text>
        </View>

        <View style={{ width: 300, marginBottom: 20 }}>
          <AnimatedCodeInput
                  value={this.state.phone_validation_code}
                  numberOfInputs={6}
                  codeContainerStyle={{ width: 45, height: 60, borderWidth: 2, borderColor: '#e7e7e7', fontSize: 12 }}
                  activeCodeContainerStyle={{ borderWidth: 2, borderColor: Colors.PRIMARY, width: 45, height: 60, paddingTop: Platform.OS === 'web' ? 25 : 0 }}
                  textContentType='oneTimeCode'
                  textColor='#474747'
                  onChangeText={(code) => {
                    this.setState({ ...this.state, phone_validation_code: code });
                  }}
                  onSubmitCode={() => {
                    this.validate_phone_code();
                  }}
                />
        </View>

        { /* <Input value={this.state.phone_validation_code}
               placeholder={ 'Code' }
               style={{ marginBottom: 35, width: 100, textAlign: 'center' }}
               textContentType='oneTimeCode'
               keyboardType='number-pad'
               onChangeText={ (input_text) => {
                 let code_length = input_text.length;
                 this.setState({ ...this.state, phone_validation_code: input_text })
                 if (code_length === 6) {
                   this.validate_phone_code();
                 }
               }}/> */ }
        {phone_verify_error ? <Text style={styles.error_message}>{this.state.phone_verify_error}</Text> : null}
         <Button title='Continue'
                 loading={loading}
                 style={{ width: 200, marginBottom: 10 }}
                 onPress={ this.validate_phone_code }/>

         <TouchableOpacity onPress={this.backToPhone}>
           <Text style={{ fontSize: 16, fontWeight: 'bold', color: Colors.PRIMARY, marginTop: 5 }}>Resend Code</Text>
         </TouchableOpacity>

    </View>
  }

  render() {

    if (!this.props.display) {
      return null;
    }

    return (
      <View style={styles.main_container}>
        { this.render_user_inputs_section()        }
        { this.render_phone_number_input_section() }
        { this.render_validation_code_section()    }
      </View>
    );
  }

}

const styles = StyleSheet.create({
  content_container: {
    backgroundColor: 'white',
    borderRadius: 15,
    borderWidth: 1,
    borderColor: '#e7e7e7',
    padding: 20,
  },
  main_container: {
    flex: 1,
    padding: 20,
  },
  error_message: {
    color: 'red'
  }
});

export default SignUpPriceSelection
